const translations = {
    headerTitle: {
        type: 'text',
        defaultValue: '<b>Reset</b> password',
    },
    headerDescription: {
        type: 'text',
        defaultValue: 'Enter the email address for your account, and we will send you a password reset link.',
    },
    inputPassword: {
        type: 'text',
        defaultValue: 'Password',
    },
    inputRepeatPassword: {
        type: 'text',
        defaultValue: 'Repeat password',
    },
    buttonPasswordVisible: {
        type: 'text',
        defaultValue: 'Show password',
    },
    buttonPasswordInvisible: {
        type: 'text',
        defaultValue: 'Hide password',
    },
    buttonSubmit: {
        type: 'text',
        defaultValue: 'Change password',
    },
    successSendEmail: {
        type: 'text',
        defaultValue: '<span>We have sent a password reset link to the <b>provided email address</b>.</span>',
    },
    headerSuccess: {
        type: 'text',
        defaultValue: 'Password has been changed',
    },
    buttonRedirect: {
        type: 'text',
        defaultValue: 'Go to {name} dashboard',
    },
    patient: {
        type: 'text',
        defaultValue: 'Patient',
    },
    physio: {
        type: 'text',
        defaultValue: 'Physiotherapist',
    },
    buttonHomePage: {
        type: 'text',
        defaultValue: 'Go to home page',
    },
};

export default translations;
